/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DatasetAnalyzeResponse,
  DatasetCreateRequest,
  DatasetCreateResponse,
  DatasetDeleteResponse,
  DatasetGetResponse,
  DatasetListLite,
  DatasetPutResponse,
  DatasetUpdateRequest,
  DatasetUpdateResponse,
  DatasetsAnalyzeRetrieveParams,
  DatasetsDriversWithChannelsListParams,
  DatasetsDriversWithoutChannelsListParams,
  DatasetsListParams,
  DatasetsMarketsListParams,
  DatasetsPairableListParams,
  HierarchyDataset,
  MediaChannel,
  PaginatedDatasetList,
  PaginatedDatasetPairableListResponseList,
  PaginatedMarketList,
  PaginatedMediaChannelList,
  PatchedDatasetUpdateRequest,
  V2DatasetsDriversRetrieveParams,
  V2DatasetsDriversWithChannelsListParams,
  V2DatasetsDriversWithoutChannelsListParams,
  V2DatasetsListParams
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Retrieve a paginated list of datasets with filtering, search, and ordering capabilities. Supports multi-field search across name, source, category, and description. Custom filters available: scope (contextual/client), client_id, and project_id.
 * @summary List datasets
 */
export const datasetsList = (
    params?: DatasetsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedDatasetList>(
      {url: `/api/datasets/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsListQueryKey = (params?: DatasetsListParams,) => {
    return [`/api/datasets/`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsListQueryOptions = <TData = Awaited<ReturnType<typeof datasetsList>>, TError = unknown>(params?: DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsList>>> = ({ signal }) => datasetsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsListQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsList>>>
export type DatasetsListQueryError = unknown


export function useDatasetsList<TData = Awaited<ReturnType<typeof datasetsList>>, TError = unknown>(
 params: undefined |  DatasetsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsList<TData = Awaited<ReturnType<typeof datasetsList>>, TError = unknown>(
 params?: DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsList<TData = Awaited<ReturnType<typeof datasetsList>>, TError = unknown>(
 params?: DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List datasets
 */

export function useDatasetsList<TData = Awaited<ReturnType<typeof datasetsList>>, TError = unknown>(
 params?: DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new dataset with file upload and metadata (admin only). Returns an array of datasets (single dataset for files with one data column, multiple datasets for files with multiple data columns).
 * @summary Create dataset
 */
export const datasetsCreate = (
    datasetCreateRequest: DatasetCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatasetCreateResponse>(
      {url: `/api/datasets/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: datasetCreateRequest, signal
    },
      );
    }
  


export const getDatasetsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsCreate>>, TError,{data: DatasetCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsCreate>>, TError,{data: DatasetCreateRequest}, TContext> => {

const mutationKey = ['datasetsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsCreate>>, {data: DatasetCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  datasetsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsCreate>>>
    export type DatasetsCreateMutationBody = DatasetCreateRequest
    export type DatasetsCreateMutationError = unknown

    /**
 * @summary Create dataset
 */
export const useDatasetsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsCreate>>, TError,{data: DatasetCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsCreate>>,
        TError,
        {data: DatasetCreateRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get a single dataset by ID
 * @summary Retrieve dataset
 */
export const datasetsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatasetGetResponse>(
      {url: `/api/datasets/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getDatasetsRetrieveQueryKey = (id: string,) => {
    return [`/api/datasets/${id}`] as const;
    }

    
export const getDatasetsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof datasetsRetrieve>>, TError = DatasetGetResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsRetrieve>>> = ({ signal }) => datasetsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsRetrieve>>>
export type DatasetsRetrieveQueryError = DatasetGetResponse


export function useDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRetrieve>>, TError = DatasetGetResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRetrieve>>, TError = DatasetGetResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRetrieve>>, TError = DatasetGetResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve dataset
 */

export function useDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRetrieve>>, TError = DatasetGetResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Fully update a dataset with optional file upload
 * @summary Update dataset (full)
 */
export const datasetsUpdate = (
    id: string,
    datasetUpdateRequest: DatasetUpdateRequest,
 ) => {
      
      
      return customInstance<DatasetPutResponse>(
      {url: `/api/datasets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: datasetUpdateRequest
    },
      );
    }
  


export const getDatasetsUpdateMutationOptions = <TError = DatasetPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsUpdate>>, TError,{id: string;data: DatasetUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsUpdate>>, TError,{id: string;data: DatasetUpdateRequest}, TContext> => {

const mutationKey = ['datasetsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsUpdate>>, {id: string;data: DatasetUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  datasetsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsUpdate>>>
    export type DatasetsUpdateMutationBody = DatasetUpdateRequest
    export type DatasetsUpdateMutationError = DatasetPutResponse

    /**
 * @summary Update dataset (full)
 */
export const useDatasetsUpdate = <TError = DatasetPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsUpdate>>, TError,{id: string;data: DatasetUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsUpdate>>,
        TError,
        {id: string;data: DatasetUpdateRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Partially update a dataset with optional file upload
 * @summary Update dataset
 */
export const datasetsPartialUpdate = (
    id: string,
    patchedDatasetUpdateRequest: PatchedDatasetUpdateRequest,
 ) => {
      
      
      return customInstance<DatasetUpdateResponse>(
      {url: `/api/datasets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedDatasetUpdateRequest
    },
      );
    }
  


export const getDatasetsPartialUpdateMutationOptions = <TError = DatasetUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsPartialUpdate>>, TError,{id: string;data: PatchedDatasetUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsPartialUpdate>>, TError,{id: string;data: PatchedDatasetUpdateRequest}, TContext> => {

const mutationKey = ['datasetsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsPartialUpdate>>, {id: string;data: PatchedDatasetUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  datasetsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsPartialUpdate>>>
    export type DatasetsPartialUpdateMutationBody = PatchedDatasetUpdateRequest
    export type DatasetsPartialUpdateMutationError = DatasetUpdateResponse

    /**
 * @summary Update dataset
 */
export const useDatasetsPartialUpdate = <TError = DatasetUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsPartialUpdate>>, TError,{id: string;data: PatchedDatasetUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsPartialUpdate>>,
        TError,
        {id: string;data: PatchedDatasetUpdateRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Delete a dataset by ID
 * @summary Delete dataset
 */
export const datasetsDestroy = (
    id: string,
 ) => {
      
      
      return customInstance<DatasetDeleteResponse>(
      {url: `/api/datasets/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDatasetsDestroyMutationOptions = <TError = DatasetDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['datasetsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  datasetsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsDestroy>>>
    
    export type DatasetsDestroyMutationError = DatasetDeleteResponse

    /**
 * @summary Delete dataset
 */
export const useDatasetsDestroy = <TError = DatasetDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDatasetsDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Analyze a dataset with specified action and return analysis results
 * @summary Analyze dataset
 */
export const datasetsAnalyzeRetrieve = (
    id: string,
    params: DatasetsAnalyzeRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatasetAnalyzeResponse>(
      {url: `/api/datasets/${id}/analyze`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsAnalyzeRetrieveQueryKey = (id: string,
    params: DatasetsAnalyzeRetrieveParams,) => {
    return [`/api/datasets/${id}/analyze`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsAnalyzeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError = DatasetAnalyzeResponse>(id: string,
    params: DatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsAnalyzeRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>> = ({ signal }) => datasetsAnalyzeRetrieve(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsAnalyzeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>>
export type DatasetsAnalyzeRetrieveQueryError = DatasetAnalyzeResponse


export function useDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError = DatasetAnalyzeResponse>(
 id: string,
    params: DatasetsAnalyzeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError = DatasetAnalyzeResponse>(
 id: string,
    params: DatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError = DatasetAnalyzeResponse>(
 id: string,
    params: DatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Analyze dataset
 */

export function useDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError = DatasetAnalyzeResponse>(
 id: string,
    params: DatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsAnalyzeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsAnalyzeRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve datasets organized by channels with optional regional variants. Admin: all. Manager: ClientDataset for own client. User: ClientDataset ∩ ProjectUserSolution drivers. Paginated at channel level.
 * @summary Get datasets hierarchy organized by channels
 */
export const datasetsDriversWithChannelsList = (
    params?: DatasetsDriversWithChannelsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedMediaChannelList>(
      {url: `/api/datasets/drivers/with-channels`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsDriversWithChannelsListQueryKey = (params?: DatasetsDriversWithChannelsListParams,) => {
    return [`/api/datasets/drivers/with-channels`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsDriversWithChannelsListQueryOptions = <TData = Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError = unknown>(params?: DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsDriversWithChannelsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>> = ({ signal }) => datasetsDriversWithChannelsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsDriversWithChannelsListQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>>
export type DatasetsDriversWithChannelsListQueryError = unknown


export function useDatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError = unknown>(
 params: undefined |  DatasetsDriversWithChannelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError = unknown>(
 params?: DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError = unknown>(
 params?: DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get datasets hierarchy organized by channels
 */

export function useDatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError = unknown>(
 params?: DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsDriversWithChannelsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve datasets that have no channel, with optional regional variants. Also includes orphaned RegionDatasets under a synthetic 'No parent' dataset. Admin: all. Manager: ClientDataset for own client. User: ClientDataset ∩ ProjectUserSolution drivers. Paginated at dataset level.
 * @summary Get datasets hierarchy without channels
 */
export const datasetsDriversWithoutChannelsList = (
    params?: DatasetsDriversWithoutChannelsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedDatasetList>(
      {url: `/api/datasets/drivers/without-channels`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsDriversWithoutChannelsListQueryKey = (params?: DatasetsDriversWithoutChannelsListParams,) => {
    return [`/api/datasets/drivers/without-channels`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsDriversWithoutChannelsListQueryOptions = <TData = Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError = unknown>(params?: DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsDriversWithoutChannelsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>> = ({ signal }) => datasetsDriversWithoutChannelsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsDriversWithoutChannelsListQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>>
export type DatasetsDriversWithoutChannelsListQueryError = unknown


export function useDatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError = unknown>(
 params: undefined |  DatasetsDriversWithoutChannelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError = unknown>(
 params?: DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError = unknown>(
 params?: DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get datasets hierarchy without channels
 */

export function useDatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError = unknown>(
 params?: DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsDriversWithoutChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsDriversWithoutChannelsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Enhanced ListAPIView that automatically integrates with BaseCitrusPagination
and provides all Citrus functionality for list operations.

Usage:
    @extend_schema(tags=['Markets'])
    class MarketListView(CitrusListAPIView):
        serializer_class = MarketSerializer
        queryset = Market.objects.all()
 * @summary Get market
 */
export const datasetsMarketsList = (
    params?: DatasetsMarketsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedMarketList>(
      {url: `/api/datasets/markets`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsMarketsListQueryKey = (params?: DatasetsMarketsListParams,) => {
    return [`/api/datasets/markets`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsMarketsListQueryOptions = <TData = Awaited<ReturnType<typeof datasetsMarketsList>>, TError = unknown>(params?: DatasetsMarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsMarketsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsMarketsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsMarketsList>>> = ({ signal }) => datasetsMarketsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsMarketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsMarketsListQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsMarketsList>>>
export type DatasetsMarketsListQueryError = unknown


export function useDatasetsMarketsList<TData = Awaited<ReturnType<typeof datasetsMarketsList>>, TError = unknown>(
 params: undefined |  DatasetsMarketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsMarketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsMarketsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsMarketsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsMarketsList<TData = Awaited<ReturnType<typeof datasetsMarketsList>>, TError = unknown>(
 params?: DatasetsMarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsMarketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsMarketsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsMarketsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsMarketsList<TData = Awaited<ReturnType<typeof datasetsMarketsList>>, TError = unknown>(
 params?: DatasetsMarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsMarketsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get market
 */

export function useDatasetsMarketsList<TData = Awaited<ReturnType<typeof datasetsMarketsList>>, TError = unknown>(
 params?: DatasetsMarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsMarketsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsMarketsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve datasets that can be paired with a driver dataset **being created** (before it exists in the database).

**Important:** This endpoint is used DURING driver creation. The frontend must:
1. Analyze the driver's CSV file locally (using JavaScript/client-side libraries)
2. Extract: interval (frequency), start_date, end_date, media_input_category
3. Pass these values as query parameters to this endpoint

**Required Query Parameters:**
- `media_input_category` (required): Driver's category - must be 'reach' or 'frequency'
- `interval` (required): Driver's data frequency - 'daily', 'weekly', or 'monthly'
- `start_date` (required): Driver's start date in YYYY-MM-DD format
- `end_date` (required): Driver's end date in YYYY-MM-DD format
- `client_id` (optional): Driver's client ID - **omit if driver is contextual/public**

**Return Logic by client_id:**
- **If client_id PROVIDED:** Returns datasets from that specific client + contextual (public) datasets
- **If client_id OMITTED:** Returns ONLY contextual (public) datasets

**All returned datasets must:**
- Have matching `media_input_category` ('reach' or 'frequency')
- Be part of media channel (`part_of_media_channel=True`)
- Results are **not paginated** (returns all matching datasets)

**Compatibility Check (is_active & comment):**
Each dataset includes compatibility status:
- `is_active: true` - Dataset is fully compatible (matching interval + overlapping dates)
- `is_active: false` - Dataset has compatibility issues (see comment field)
- `comment: string|null` - Explanation of why dataset is inactive:
  * Interval mismatch (e.g., driver is 'weekly' but dataset is 'monthly')
  * No date overlap (date ranges don't intersect)
  * Multiple issues separated by ' | '

**Note:** Inactive datasets are still returned but should be disabled in the UI.

**Examples:**
- Client driver: `?media_input_category=reach&interval=weekly&start_date=2020-01-01&end_date=2023-12-31&client_id=5`
- Contextual driver: `?media_input_category=reach&interval=weekly&start_date=2020-01-01&end_date=2023-12-31` (no client_id)

**Edge Cases:**
- media_input_category not 'reach' or 'frequency' → `[]` (empty array)
- Missing required parameters → 400 error
- Invalid date format → 400 error
- client_id omitted → returns only contextual datasets (correct for contextual drivers)
 * @summary List pairable datasets
 */
export const datasetsPairableList = (
    params: DatasetsPairableListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedDatasetPairableListResponseList>(
      {url: `/api/datasets/pairable/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsPairableListQueryKey = (params: DatasetsPairableListParams,) => {
    return [`/api/datasets/pairable/`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsPairableListQueryOptions = <TData = Awaited<ReturnType<typeof datasetsPairableList>>, TError = unknown>(params: DatasetsPairableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsPairableList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsPairableListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsPairableList>>> = ({ signal }) => datasetsPairableList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsPairableList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsPairableListQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsPairableList>>>
export type DatasetsPairableListQueryError = unknown


export function useDatasetsPairableList<TData = Awaited<ReturnType<typeof datasetsPairableList>>, TError = unknown>(
 params: DatasetsPairableListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsPairableList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsPairableList>>,
          TError,
          Awaited<ReturnType<typeof datasetsPairableList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsPairableList<TData = Awaited<ReturnType<typeof datasetsPairableList>>, TError = unknown>(
 params: DatasetsPairableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsPairableList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsPairableList>>,
          TError,
          Awaited<ReturnType<typeof datasetsPairableList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsPairableList<TData = Awaited<ReturnType<typeof datasetsPairableList>>, TError = unknown>(
 params: DatasetsPairableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsPairableList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pairable datasets
 */

export function useDatasetsPairableList<TData = Awaited<ReturnType<typeof datasetsPairableList>>, TError = unknown>(
 params: DatasetsPairableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsPairableList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsPairableListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Same access as v1. Returns all matching datasets (no pagination) with id, name, and client_id only — for parent-driver pickers. Does not apply client_id/project_id query filters. Pass active_client=true to hide drivers owned by deactivated clients (contextual drivers with no client are kept).
 * @summary List datasets (v2 lite)
 */
export const v2DatasetsList = (
    params?: V2DatasetsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatasetListLite[]>(
      {url: `/api/v2/datasets/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2DatasetsListQueryKey = (params?: V2DatasetsListParams,) => {
    return [`/api/v2/datasets/`, ...(params ? [params]: [])] as const;
    }

    
export const getV2DatasetsListQueryOptions = <TData = Awaited<ReturnType<typeof v2DatasetsList>>, TError = unknown>(params?: V2DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2DatasetsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2DatasetsList>>> = ({ signal }) => v2DatasetsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2DatasetsListQueryResult = NonNullable<Awaited<ReturnType<typeof v2DatasetsList>>>
export type V2DatasetsListQueryError = unknown


export function useV2DatasetsList<TData = Awaited<ReturnType<typeof v2DatasetsList>>, TError = unknown>(
 params: undefined |  V2DatasetsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsList>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsList<TData = Awaited<ReturnType<typeof v2DatasetsList>>, TError = unknown>(
 params?: V2DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsList>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsList<TData = Awaited<ReturnType<typeof v2DatasetsList>>, TError = unknown>(
 params?: V2DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List datasets (v2 lite)
 */

export function useV2DatasetsList<TData = Awaited<ReturnType<typeof v2DatasetsList>>, TError = unknown>(
 params?: V2DatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2DatasetsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Paginated unified hierarchy for the Databook list. Same nested shape as preload: media_channels + datasets_without_channel. Pages are packed to at most `limit` flattened UI rows. `total` is the parent-driver count. Nested groups stay nested; a split group repeats its channel/parent header inside the same row budget. Lite payload — use GET /api/datasets/{id} for edit forms.
 * @summary List databook drivers (v2 unified)
 */
export const v2DatasetsDriversRetrieve = (
    params?: V2DatasetsDriversRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/datasets/drivers/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2DatasetsDriversRetrieveQueryKey = (params?: V2DatasetsDriversRetrieveParams,) => {
    return [`/api/v2/datasets/drivers/`, ...(params ? [params]: [])] as const;
    }

    
export const getV2DatasetsDriversRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError = unknown>(params?: V2DatasetsDriversRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2DatasetsDriversRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>> = ({ signal }) => v2DatasetsDriversRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2DatasetsDriversRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>>
export type V2DatasetsDriversRetrieveQueryError = unknown


export function useV2DatasetsDriversRetrieve<TData = Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError = unknown>(
 params: undefined |  V2DatasetsDriversRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsDriversRetrieve<TData = Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError = unknown>(
 params?: V2DatasetsDriversRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsDriversRetrieve<TData = Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError = unknown>(
 params?: V2DatasetsDriversRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List databook drivers (v2 unified)
 */

export function useV2DatasetsDriversRetrieve<TData = Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError = unknown>(
 params?: V2DatasetsDriversRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2DatasetsDriversRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Same access rules as v1, with a slim dataset/region payload for list UIs. Unpaginated. Fetch GET /api/datasets/{id} for full edit forms.
 * @summary Get lite datasets hierarchy organized by channels (v2)
 */
export const v2DatasetsDriversWithChannelsList = (
    params?: V2DatasetsDriversWithChannelsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MediaChannel[]>(
      {url: `/api/v2/datasets/drivers/with-channels`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2DatasetsDriversWithChannelsListQueryKey = (params?: V2DatasetsDriversWithChannelsListParams,) => {
    return [`/api/v2/datasets/drivers/with-channels`, ...(params ? [params]: [])] as const;
    }

    
export const getV2DatasetsDriversWithChannelsListQueryOptions = <TData = Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError = unknown>(params?: V2DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2DatasetsDriversWithChannelsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>> = ({ signal }) => v2DatasetsDriversWithChannelsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2DatasetsDriversWithChannelsListQueryResult = NonNullable<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>>
export type V2DatasetsDriversWithChannelsListQueryError = unknown


export function useV2DatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError = unknown>(
 params: undefined |  V2DatasetsDriversWithChannelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError = unknown>(
 params?: V2DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError = unknown>(
 params?: V2DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get lite datasets hierarchy organized by channels (v2)
 */

export function useV2DatasetsDriversWithChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError = unknown>(
 params?: V2DatasetsDriversWithChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2DatasetsDriversWithChannelsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Same access rules as v1, with a slim dataset/region payload for list UIs. Unpaginated. Fetch GET /api/datasets/{id} for full edit forms.
 * @summary Get lite datasets hierarchy without channels (v2)
 */
export const v2DatasetsDriversWithoutChannelsList = (
    params?: V2DatasetsDriversWithoutChannelsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HierarchyDataset[]>(
      {url: `/api/v2/datasets/drivers/without-channels`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2DatasetsDriversWithoutChannelsListQueryKey = (params?: V2DatasetsDriversWithoutChannelsListParams,) => {
    return [`/api/v2/datasets/drivers/without-channels`, ...(params ? [params]: [])] as const;
    }

    
export const getV2DatasetsDriversWithoutChannelsListQueryOptions = <TData = Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError = unknown>(params?: V2DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2DatasetsDriversWithoutChannelsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>> = ({ signal }) => v2DatasetsDriversWithoutChannelsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2DatasetsDriversWithoutChannelsListQueryResult = NonNullable<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>>
export type V2DatasetsDriversWithoutChannelsListQueryError = unknown


export function useV2DatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError = unknown>(
 params: undefined |  V2DatasetsDriversWithoutChannelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError = unknown>(
 params?: V2DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>,
          TError,
          Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2DatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError = unknown>(
 params?: V2DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get lite datasets hierarchy without channels (v2)
 */

export function useV2DatasetsDriversWithoutChannelsList<TData = Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError = unknown>(
 params?: V2DatasetsDriversWithoutChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2DatasetsDriversWithoutChannelsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2DatasetsDriversWithoutChannelsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



